
import { useEffect } from "react";
import { trackPageView } from "./tracking";

let sent = false;

/** Fires one page_view per HTML page load. Call once per page component. */
export function usePageView() {
  useEffect(() => {
    if (sent) return; // Prevent duplicate events from React StrictMode.

    sent = true;

    trackPageView(window.location.pathname, document.title);
  }, []);
}
